import { SellData } from '@app/store/sell'

export function getUniqueId(length: number) {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length))
  }
  return result
}

export const createServerName = (_serverId: string | number) => {
  let serverName = ''
  let serverId = _serverId
  serverId = String(serverId)
  if (!serverId.slice(1)) {
    serverName = `S-${serverId}`
  } else {
    serverName = `S-${parseInt(serverId.slice(1))}`
  }
  return serverName
}

export const createPlayerName = (item: SellData['list'][number]) =>
  `(${createServerName(item.kid)}) ${item.name}`

export const createPlayerName2 = (item: SellData['list'][number]) =>
  `${createServerName(item.kid)} ${item.name}`

export const getColorStyle = (item: SellData['list'][number]) => {
  let color = '#000000'
  switch (item.color) {
    case 1:
      color = '#B76907'
      break

    case 2:
      color = '#2A88A8'
      break

    default:
      color = '#348632'
      break
  }

  return { color }
}
